import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import { strings } from '@client/localization/Localization';
import indicators from '@client/shared/js/indicators';
import shapes from '@client/shared/js/shapes';
import logo from '@client/shared/js/logo';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './uspSection.scss';

class UspSection extends PureComponent {
  onCtaClick = (event) => {
    event.preventDefault();
    this.props.history.push(this.props.ctaUrl);
  };

  getDescriptionTextClassNames() {
    return classNames({
      [`${themeStyles.uspLeadText} ${styles.leadText}`]: !this.props
        .classNameDescriptionText,
      [this.props.classNameDescriptionText]: this.props
        .classNameDescriptionText,
    });
  }

  render() {
    const { className, title, description, ctaText, imageUrl } = this.props;
    return (
      <div
        className={
          className ? `${styles.uspSection} ${className}` : styles.uspSection
        }
        style={{ backgroundImage: `url(${logo.logo_blue_2x})` }}
      >
        <div className={styles.uspSectionContentContainer}>
          <div className={styles.contentContainer}>
            <div className={styles.textContainer}>
              <div className={`${themeStyles.uspTitle} ${styles.title}`}>
                {title}
              </div>
              <div className={this.getDescriptionTextClassNames()}>
                {description}
              </div>
            </div>
            <div
              className={styles.videographicContainer}
              style={{ backgroundImage: `url(${imageUrl})` }}
            >
              {ctaText && (
                <>
                  <button
                    type="button"
                    className={`${themeStyles.btnPrimary} ${styles.button}`}
                    onClick={this.onCtaClick}
                  >
                    <img src={indicators.arrow_black} />
                    {ctaText}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <img
          className={styles.shapeBottomLeft}
          src={shapes.graphic_panel_2x}
          alt="Factuals graphic panel"
        />
      </div>
    );
  }
}

UspSection.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  classNameDescriptionText: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default withRouter(UspSection);
